<template>
  <NuxtLink
    class="block w-fit text-center"
    :title="$t('logoTitle')"
    :to="locale === $i18n.availableLocales[0] ? '/' : '/' + locale"
    :aria-label="$t('logoTitle')"
    @click="menuHide"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="81"
      height="80"
      viewBox="0 0 81 80"
      fill="none"
      class="h-full w-full"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M46.6705 74.0898L50.9925 50.4923L74.59 46.1702L75.9884 45.9141L74.7375 45.2385L53.6743 33.8624L56.8538 10.0659L57.0417 8.65918L56.0135 9.63743L38.6256 26.1808L16.9649 15.7976L15.6819 15.1826L16.2981 16.465L26.6809 38.0752L10.1377 55.4629L9.15942 56.4911L10.5661 56.3031L34.3622 53.1237L45.7385 74.2368L46.4139 75.4904L46.6705 74.0898ZM40.8369 40.3367L35.5456 50.7682L14.9346 53.5398L40.8369 40.3367ZM40.8369 40.3367L54.0401 14.4343L39.0228 28.7965L40.8369 40.3367ZM40.8369 40.3367L29.2968 38.4721L20.3267 19.7761L40.8369 40.3367ZM40.8369 40.3367L69.5613 44.8721L51.2684 35.0453L40.8369 40.3367ZM40.8369 40.3367L45.3724 69.0611L49.1015 48.6516L40.8369 40.3367Z"
        fill="currentColor"
      />
    </svg>
  </NuxtLink>
</template>

<script setup lang="ts">
const { locale } = useI18n()
const { menuHide } = useMenu()
</script>
